<script setup lang="ts">
import { useFilesStore } from "@/stores/files";
const fileStore = useFilesStore();
</script>
<template>
    <button class="button-primary" @click="fileStore.finalize" :disabled="!fileStore.canFinalize">Finalize</button>
</template>

<style scoped lang="scss">
button {
    text-transform: uppercase;
    font-size: 24px;
    width: 240px;
}
</style>
